import {
  CHAT_MESSAGE_TAG_PRIORITY_LIST,
  ChatAssignmentStatusEnum,
  ChatBucket,
  IChatListItem
} from '../pages/WhatsappChatbot/types';
import firebase from 'firebase/app';
import store from '../store';
import { dateFormat } from './DateHelper';

export function removeChatItemFromChatBucket(chatBuckets: ChatBucket, chatItem: IChatListItem) {
  const { referenceId } = chatItem;
  Object.keys(chatBuckets).forEach(key => {
    const chats = chatBuckets[key];
    if (chats[referenceId]) {
      delete chats[referenceId];
      return;
    }
  });
}

export function addChatItemToChatBucket(chatBuckets: ChatBucket, chatItem: IChatListItem) {
  const { tag, referenceId } = chatItem;
  const chats = chatBuckets[tag];
  if (chats) {
    chats[referenceId] = chatItem;
  } else {
    chatBuckets[tag] = {
      ...chatBuckets[tag],
      [referenceId]: chatItem
    };
  }
}

export const getChatBucketsFromRedux = () => {
  return store.getState()?.whatsappChatbot.chatBuckets;
};

export const handleFirestoreUpdates = (
  docSnapshot: firebase.firestore.DocumentChange<firebase.firestore.DocumentData>,
  addedCases: IChatListItem[],
  modifiedCases: IChatListItem[],
  removedCases: IChatListItem[]
) => {
  const { type, doc } = docSnapshot;
  const { id } = doc;
  const data = doc.data();
  switch (type) {
    case 'added':
      addedCases.push({
        ...data,
        referenceId: id
      } as IChatListItem);
      break;
    case 'modified':
      modifiedCases.push({
        ...data,
        referenceId: id
      } as IChatListItem);
      break;
    case 'removed':
      removedCases.push({
        ...data,
        referenceId: id
      } as IChatListItem);
      break;
    default:
      break;
  }
};

export const getCustomerInitials = (customerName: string) => {
  const splitName = customerName.split(' ');
  switch (splitName.length) {
    case 0:
      return '';
    case 1:
      return splitName[0].charAt(0);
    default:
      return `${splitName[0].charAt(0)}${splitName[splitName.length - 1].charAt(0)}`;
  }
};

export const getChatTimeDifference = (createdAt: number): string => {
  const currentTime = new Date();
  const creationTime = new Date(createdAt);
  // this is timespamp difference
  const diff = Math.floor((currentTime.getTime() - creationTime.getTime()) / 1000);
  if (diff < 60) {
    return `now`;
  }
  const mins = Math.floor(diff / 60);
  if (mins < 60) {
    return `${mins}${mins <= 1 ? 'min' : 'mins'}`;
  }
  const hours = Math.floor(diff / 60);
  if (hours < 24) {
    return `${hours}${hours <= 1 ? 'hr' : 'hrs'}`;
  }
  if (currentTime.getFullYear() === creationTime.getFullYear()) {
    return dateFormat(creationTime, `dd MMM`);
  }
  return dateFormat(creationTime, `dd MMM, YYYY`);
};

export const setChatList = (chatBuckets: ChatBucket) => {
  const filteredList: IChatListItem[] = [];
  CHAT_MESSAGE_TAG_PRIORITY_LIST.forEach(tag => {
    chatBuckets[tag] &&
      Object.entries(chatBuckets[tag])
        .sort((chat1, chat2) => {
          return chat2[1].messageTimestamp - chat1[1].messageTimestamp;
        })
        .forEach(([key, value]) => {
          if (value.chatAssignmentStatus === ChatAssignmentStatusEnum.REVOKED) {
            return;
          }
          filteredList.push(value);
        });
  });
  return filteredList;
};

export function inputKeyGenerator(customerId: string, chatReferenceId: string) {
  return `${customerId}-${chatReferenceId}-txt`;
}
